// Worthify i18n — DE locale. Keys must mirror locales/en.js;
// missing keys fall back to English in useTranslation.
export const de = {
    // Header
    tagline: "Lohnt es sich wirklich?",
    
    // Main heading
    mainHeading: "Kenne den wahren Wert!",
    heroSubtext: "Eine Prüfung kann Ihnen Tausende sparen.",
    heroLine1: "Prüfen Sie jedes Auto in Sekunden und vermeiden Sie teure Fehler.",
    heroLine2: "Sehen Sie die versteckten Probleme bevor Sie kaufen.",
    heroLine3: "Eine Prüfung kann Ihnen Tausende sparen.",
    
    // Input placeholders
    registrationPlaceholder: " ",
    pricePlaceholder: " ",
    priceHelperText: "Geben Sie den Angebotspreis zum Vergleich mit dem realen Wert ein",
    listingUrlPlaceholder: "Angebots-URL eingeben (optional)",
    vinPlaceholder: "z.B. WAUZZZ4L1BD123456",
    vinHelperText: "VIN verbessert die Genauigkeit der Motor- und Risikoanalyse",
    vinInvalid: "Ungültiges VIN-Format (muss 17 Zeichen haben)",
    vinTooltip: "VIN hilft, den genauen Motor und versteckte Probleme zu identifizieren",
    vinPreviewLoading: "VIN wird dekodiert…",
    vinPreviewDetected: "Erkannt",
    vinPreviewUnknown: "VIN konnte nicht dekodiert werden — Analyse funktioniert trotzdem",
    regHelperText: "Geben Sie ein beliebiges Kennzeichen ein",
    ctaHelperText: "Jedes Fahrzeug jetzt kostenlos prüfen",
    
    // Buttons
    analyzeButton: "JETZT PRÜFEN",
    checkingVehicle: "Fahrzeug wird geprüft...",
    trustText: "Keine Anmeldung • Echte DVSA + DVLA Daten • 🛡 More Than HPI Check • Sofort-Verdikt",
    downloadButton: "Vollständigen Bericht herunterladen (nur £1)",
    generatingPdf: "PDF wird erstellt...",
    newSearch: "← Neue Suche",
    
    // Error messages
    errorEmptyRegistration: "Bitte geben Sie eine Fahrzeugregistrierung ein",
    errorVehicleNotFound: "Fahrzeug nicht gefunden. Bitte überprüfen Sie die Registrierungsnummer.",
    errorServiceUnavailable: "Dienst nicht verfügbar, bitte versuchen Sie es erneut.",
    errorReportFailed: "Bericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    
    // Results - Risk level
    riskLevel: "Risikostufe",
    tickerFailedMots: "MOT NICHT BESTANDEN",
    tickerMiles: "MEILEN",
    tickerDangerous: "GEFÄHRLICH",
    verdictWorthBuying: "GUTES ANGEBOT",
    verdictBeCareful: "VORSICHT",
    verdictAvoid: "VERMEIDEN",
    verdictExplanationLow: "Saubere TÜV-Geschichte. Solide Kaufentscheidung.",
    verdictShortExplanationLow: "Historie wirkt sauber. Vor dem Kauf trotzdem prüfen.",
    verdictShortExplanationMedium: "Bekannte Probleme in der Historie. Nur zum richtigen Preis.",
    verdictShortExplanationHigh: "Erhebliche Risiken. Budget für Reparaturen einplanen — oder weggehen.",
    verdictShortExplanationScam: "Preis verdächtig niedrig. Als Hochrisikokauf behandeln.",
    verdictExplanationMedium: "Einige Probleme erkannt. Vor dem Kauf genau prüfen.",
    verdictExplanationHigh: "Schwerwiegende Probleme gefunden. Hohes Risiko teurer Reparaturen.",
    verdictExplanationScam: "Dieses Angebot ist höchst verdächtig. Vermeiden Sie diesen Kauf.",
    verdictSubtextLow: "Dieser Preis erscheint angemessen basierend auf dem realen Wert.",
    verdictSubtextMedium: "Etwas stimmt nicht. Vor dem Kauf genau prüfen.",
    verdictSubtextHigh: "Schwerwiegende Probleme erkannt. Wir empfehlen dringend, dieses Fahrzeug zu vermeiden.",
    verdictSubtextScam: "Dieses Angebot ist höchst verdächtig. Vermeiden Sie diesen Kauf.",
    unlockFullReport: "VOLLSTÄNDIGEN RISIKOBERICHT FREISCHALTEN — NUR £1",
    verdictIncludesLine1: "Enthält versteckte Probleme, frühere Schäden & Risikoanalyse",
    verdictIncludesLine2: "Kein Konto erforderlich • Sofortiger Zugang",
    verdictClarityLine: "Zugang gilt nur für diese Sitzung",
    verdictAvoidMistakes: "Vermeiden Sie kostspielige Fehler vor dem Kauf",
    verdictTrustedBy: "Von britischen Autokäufern vertraut",
    verdictSecureLine: "Sichere Zahlung • Echte Fahrzeugdaten • Sofortige Ergebnisse",
    whatYouUnlock: "Was Sie freischalten",
    unlockItem1: "Versteckte Unfall- und Schadensrisiken",
    unlockItem2: "Erkennung von Kilometerbetrug",
    unlockItem3: "Genaue Reparaturkosten (£)",
    unlockItem4: "Verhandlungsvorteil — wie viel Preis senken",
    unlockItem5: "Endgültiges Urteil: KAUFEN / VERHANDELN / VERMEIDEN",
    limitedOffer: "Einführungspreis: £1",
    unlockCtaNew: "Detailbericht für £1 freischalten →",
    poweredByLine: "Einmaliger Zugang • Echte Daten • Expertenanalyse",
    verdictHighCostWarning: "Das könnte Sie mehr kosten als das Auto selbst.",
    verdictBackLink: "← Zurück",
    paymentProcessing: "Zahlung wird verarbeitet...",
    checkingPayment: "Zahlungsstatus wird überprüft...",
    paymentConfirmedTitle: "Zahlung bestätigt!",
    paymentConfirmedSub: "Ihr Bericht wird vorbereitet…",
    paymentVerifyTitle: "Zahlungsstatus wird überprüft…",
    paymentVerifySub: "Wir bestätigen Ihre Zahlung mit Stripe – das dauert in der Regel nur wenige Sekunden. Bitte schließen Sie dieses Fenster nicht.",
    paymentVerifySecure: "Sichere Zahlung über Stripe",
    pdfDownloadedToast: "✓ Bericht heruntergeladen",
    paymentVerifyingBanner: "Ihre Zahlung wird bestätigt. Das PDF wird automatisch heruntergeladen, sobald die Zahlung bestätigt ist.",
    redFlagsTitle: "Warnsignale",
    noRedFlags: "Keine Warnsignale — saubere Geschichte",
    yourAskingPrice: "Ihr Angebotspreis",
    marketMedianShort: "Realer Wert",
    suspiciousPrice: "Verdächtig — unter Marktwert",
    unlockReportCta: "VOLLSTÄNDIGEN RISIKOBERICHT FREISCHALTEN — NUR £1",
    pdfButtonSubtext: "Versteckte Risiken, Reparaturkosten & Verhandlungsvorteile darin",
    pdfButtonSubtext2: "Speichern, teilen oder beim Autokauf verwenden",
    lossWarning: "Sie könnten {amount} verlieren",
    negotiationPowerTitle: "Verhandlungsmacht",
    youCanNegotiate: "Sie können verhandeln",
    expertScriptLabel: "Experten-Verhandlungsskript",
    copyMessage: "Nachricht kopieren",
    confirmedMotIssues: "bestätigte MOT-Mängel",
    expertSellerScript: "Hallo — ich interessiere mich wirklich für das Auto und bin bereit, schnell zu entscheiden. Ich habe die MOT-Historie unabhängig von Worthify prüfen lassen und der Bericht weist {target} an sofortigen, realistischen Reparaturkosten aus: {issues}. Das sind keine Worst-Case-Zahlen — das sind die tatsächlichen Kosten, um das zu beheben, was das MOT bereits zeigt. Entsprechend bräuchte ich eine Preisreduzierung um {target}.",
    expertSellerScriptClose: "Wenn wir uns auf {finalPrice} einigen können, kann ich heute alles abschließen.",
    worthifyExpertsSuggest: "Worthify-Experten empfehlen zu verhandeln",
    askingPriceLabel: "Angebotspreis",
    realValueWorthifyLabel: "Realer Wert (Worthify)",
    realValueGvdLabel: "Marktwert (DVLA-Register)",
    navHome: "Start",
    navAbout: "Über uns",
    navPricing: "Preise",
    navFaq: "FAQ",
    navContact: "Kontakt",
    scoreAdjustedBadge: "Mit Premium-Daten aktualisiert",
    penaltyLabel_theft: "Diebstahlmeldung (PNC)",
    penaltyLabel_finance: "Offene Finanzierung",
    penaltyLabel_mileage_anomaly: "Kilometeranomalie",
    penaltyLabelWriteOff: "Totalschaden-Eintrag",
    penaltyLabelWriteOff_A: "Totalschaden Kat. A",
    penaltyLabelWriteOff_B: "Totalschaden Kat. B",
    penaltyLabelWriteOff_S: "Totalschaden Kat. S",
    penaltyLabelWriteOff_N: "Totalschaden Kat. N",
    penaltyLabelWriteOff_D: "Totalschaden Kat. D",
    penaltyLabelWriteOff_X: "Totalschaden Kat. X",
    penaltyPillAvoid: "Vermeiden",
    penaltyPillCaution: "Vorsicht",
    plainEnglishKickerAvoid: "REGISTER-URTEIL",
    plainEnglishKickerCaution: "REGISTER-URTEIL",
    simpleExplanationCardSubAvoid: "Tippe, um zu sehen, warum der Score gefallen ist",
    simpleExplanationCardSubCaution: "Tippe für die Registerdaten",
    realValueWorthifySub: "mit aktuellem Zustand und Mängeln",
    anchorFreeBadge: "Unabhängig · ohne Ankereffekt",
    marketValueLabel: "Marktwert",
    worthifyValuationTitle: "Worthify-Bewertung",
    worthifyExpertValuesThisCarAt: "Worthify-Experten bewerten dieses Auto mit",
    withCurrentStateAndDefects: "mit seinem aktuellen Zustand und Mängeln",
    valuationGuidanceExplainer: "Idealerweise sollte der Angebotspreis nahe an diesem Wert liegen. Deutlich höher bedeutet Überzahlung. Deutlich niedriger ist ein Warnsignal — versteckte Schäden, Totalschaden-Einstufung oder Betrug. Fragen Sie nach, bevor Sie zahlen.",
    negotiationGapExplainer: "Angebotspreis {asking}, realer Worthify-Wert {realValue}. Die Differenz von {gap} spiegelt den aktuellen Zustand wider und sollte Teil Ihrer Verhandlung sein.",
    suspiciouslyCheapWarning: "{asking} bei einem realen Wert von {realValue} ist ungewöhnlich niedrig. Autos werden nicht ohne Grund so günstig verkauft — prüfen Sie versteckte Schäden, fehlende Papiere, offene Finanzierungen oder Totalschaden-Einstufung, bevor Sie zahlen.",
    fairOrBelowExplainer: "{asking} bei einem realen Wert von {realValue} — das ist fair oder bereits unter der Worthify-Bewertung. Keine nennenswerte Verhandlungsspanne aus der Bewertung allein, Sie können aber die Reparaturkosten als Hebel nutzen.",
    offTheAskingPrice: "vom Angebotspreis abziehen",
    basedOnTheseIssues: "Basierend auf diesen bestätigten Mängeln",
    realisticRepairCost: "Realistische Reparaturkosten",
    priceAboveMarket: "Angebotspreis über Marktwert",
    overMarketValue: "über dem typischen Marktwert",
    negotiationExplainer: "Dieser Betrag basiert auf den realen Reparaturkosten dessen, was das MOT tatsächlich zeigt — nicht auf Worst-Case-Szenarien. Nutzen Sie ihn als Ausgangspunkt im Gespräch mit dem Verkäufer.",
    useThisToLowerPrice: "Nutzen Sie dies, um den Preis zu senken",
    totalRepairCostRange: "Gesamte Reparaturkostenspanne",
    whatToSayToSeller: "Was Sie dem Verkäufer sagen sollten",
    verdictAvoidCar: "FINGER WEG VON DIESEM AUTO",
    verdictShortBad: "Sehr schlechter Wert.",
    verdictShortMedium: "Vorsicht geboten.",
    verdictShortGood: "Solider Kauf.",
    verdictSubShortBad: "Hochrisikofahrzeug.",
    verdictSubShortMedium: "Einige Probleme erkannt.",
    verdictSubShortGood: "Fahrzeug mit sauberer Historie.",
    scoreCardSubtext: "Reparaturkosten \u00B7 Versteckte Probleme \u00B7 Verhandlungsvorteil",
    potentialLossTitle: "Potenzieller Verlust beim Kauf dieses Autos",
    overpricedByLabel: "Überteuert um",
    totalPotentialLoss: "Gesamter potenzieller Verlust",
    totalEstimatedCost: "Gesamte geschätzte Kosten",
    detailedPotentialCosts: "Detaillierte potenzielle Risiken & Kosten",
    bigCostHeadline: "Erwartete künftige Investition: {amount}",
    costSubtitleExplanation: "Realistische Kosten, mit denen Sie in den nächsten 12-24 Monaten rechnen sollten — basierend auf bestätigten Mängeln, der Motorenfamilie und typischen Schwachstellen der Plattform.",
    expectedCostTitle: "Erwartete Haltungskosten (12–24 Monate)",
    expectedCostTypicalSuffix: "typisch",
    expectedCostRangeSuffix: "realistische Spanne",
    expectedCostRelativePrefix: "≈",
    expectedCostRelativeSuffix: "des Fahrzeugwerts",
    expectedCostDriversTitle: "Treiber:",
    expectedCostWorstTitle: "Worst Case",
    expectedCostWorstBody: "Bis zu {amount}+ bei einem größeren Schaden ({worst_drivers}).",
    expectedCostFootnote: "Basierend auf MOT-Historie, bekannten Motor-Schwachstellen und Reparatur-Statistiken.",
    expectedCostNoData: "Aktuell keine harten Kostenfaktoren in der Historie — beim nächsten Service prüfen.",
    paywallTeaserLow: "Auf dem Papier solide. Der vollständige Breakdown zeigt, was vor dem Kauf zu prüfen ist.",
    paywallTeaserMedium: "Wir haben Dinge gefunden, die Sie vor der Zahlung kennen sollten. Vollständiger Breakdown für £1.",
    paywallTeaserHigh: "Mehrere Risiken voraus. Sehen Sie genau, was sie kosten — bevor der Verkäufer es tut.",
    paywallTeaserScam: "Der Preis wirkt zu gut, um wahr zu sein. Vollständiger Breakdown — bevor Sie überweisen.",
    paywallTeaserCTA: "Vollständigen Bericht freischalten — £1",
    expertSellerScriptNoHistory: "Hallo — ich habe ernsthaftes Interesse am Wagen. Worthify hat eine unabhängige Bewertung erstellt, basierend auf Motorenfamilie, Plattform-Zuverlässigkeit und Zustand — der realistische Wert liegt bei {realValue}. Damit es für beide Seiten fair ist, müsste der Preis um {target} reduziert werden.",
    expertSellerScriptValuationOnly: "Hallo — ich möchte diese Woche entscheiden. Die unabhängige Worthify-Bewertung — basierend auf Motor, Plattform und Zustand — liegt bei {realValue}. Diesen Betrag würde ich heute zahlen.",
    whyScoreTitle: "Warum diese Punktzahl",
    whyScoreNoHistorySub: "Keine TÜV-Historie — die Bewertung stützt sich auf Motor- und Plattformdaten:",
    whyScoreWithHistorySub: "Diese Faktoren bestimmen das Ergebnis:",
    whyScoreFactorEngine: "Risiko der Motorenfamilie",
    whyScoreFactorPlatform: "Risiko der Modellplattform",
    whyScoreFactorHistory: "TÜV-Historienmuster",
    whyScoreFactorUsage: "Nutzungs- / Kilometerprofil",
    whyScoreFactorSafety: "Crashtest-Bewertung",
    whyScoreNoHistoryHint: "Neuwagen ohne Prüfhistorie starten niedriger, weil wir nicht sehen können, wie dieses konkrete Fahrzeug tatsächlich gefahren und gewartet wurde — nur wie sich Motor und Plattform im Schnitt verhalten.",
    familyDeltaBetter: "Ihr konkreter {make_model} schneidet {pts} Punkte besser ab als der Durchschnitt der {family} ({n} analysierte Fahrzeuge).",
    familyDeltaWorse: "Ihr konkreter {make_model} schneidet {pts} Punkte schlechter ab als der Durchschnitt der {family} ({n} analysierte Fahrzeuge).",
    familyDeltaSame: "Ihr konkreter {make_model} liegt genau im Durchschnitt der {family}-Familie ({n} analysierte Fahrzeuge).",
    socialProofTitle: "Muster in dieser Motorenfamilie",
    socialProofSubtitle: "Bei {n} analysierten {family}:",
    socialProofIssueRow: "{pct}% hatten {issue}",
    confidenceBadgeLabel: "Sicherheit",
    confidenceHigh: "HOCH",
    confidenceMedium: "MITTEL",
    confidenceLow: "NIEDRIG",
    confidenceConsensus: "{n}-KI-Konsens",
    vinVerifiedLabel: "VIN verifiziert",
    vinVerifiedSource: "NHTSA-Dekodierung",
    vinVerifiedTooltip: "Motorvariante, Ausstattung und Werk aus Ihrer VIN identifiziert — Analyse präziser als ohne VIN.",
    loadingFactPeers: "Abgleich mit {n} bereits analysierten {family}",
    loadingFactPeersFew: "Bild für diese Motorenfamilie wird aufgebaut — bislang weniger als 5 Vergleichsfahrzeuge",
    loadingFactMOT: "{n} TÜV-Berichte für dieses Fahrzeug werden gelesen",
    loadingFactMOTNew: "Fabrikneuer Wagen — noch keine TÜV-Prüfung registriert",
    loadingFactAge: "{make} {model} ({year}) — typische Schwachstellen werden geladen",
    loadingFactScoring: "Worthify-Scoring läuft — keine einzelne KI entscheidet allein",
    loadingFactSafety: "Euro-NCAP-Crashtestdaten werden abgerufen",
    minimalRisk: "Minimales Risiko",
    scoreLabel: "Worthify Score",
    riskFactors: "Risikofaktoren",
    fullAnalysisInPdf: "Vollständige Risikoerklärung, Verhandlungstipps & TÜV-Historie im PDF-Bericht",
    pdfUpsellTitle: "Vollständigen Risikobericht erhalten",
    pdfIncludes1: "Konkrete Reparaturkostenschätzungen",
    pdfIncludes2: "Verhandlungsvorteil (£-Beträge)",
    pdfIncludes3: "Klare Kauf-/Vermeidungsempfehlung",
    pdfIncludes4: "Detaillierte Risikoanalyse",
    pdfIncludes5: "Einblicke in Motor und Zuverlässigkeit",
    topResultCta: "Hilfe erhalten",
    topResultSupportCopy: "Was auch immer das Ergebnis ist — wir stehen an Ihrer Seite. Echte Zahlen, echte Hebel, echter Schutz.",
    unlockSectionHeadline: "Sie müssen kein Autoexperte sein, um ein gutes Auto zu kaufen. Laden Sie das PDF mit Richtlinien und Daten herunter, um den Kaufpreis zu senken. Sehen Sie die vollständige Analyse in einfacher Sprache. Lassen Sie sich nicht täuschen.",
    unlockSectionCta: "Freischalten 🔓 / PDF herunterladen / Erweiterte Daten für £1",
    resultVerdictLabel: "Urteil",
    riskOutlookLabel: "Risikoaussicht",
    potentialLossLabel: "Möglicher Verlust",
    decisionMoodLabel: "Entscheidungsgefühl",
    heroCaptionHigh: "Dieses Auto könnte teuer im Unterhalt werden.",
    heroCaptionMedium: "Denken Sie zweimal nach, bevor Sie zusagen.",
    heroCaptionLow: "Dieses Angebot wirkt sicherer als die meisten.",
    costAlertLabel: "Kostenalarm",
    vehicleSnapshotLabel: "Fahrzeugüberblick",
    priorityReviewLabel: "Wichtigste Risiken",
    unlockPremiumSection: "Premium-Bereich freischalten",
    fullIssuesEyebrow: "Alle Probleme",
    advancedDataLabel: "Erweiterte Daten",
    pdfUnlockLabel: "PDF-Freischaltung",
    aiSummaryTitle: "Expertenzusammenfassung",
    aiAnalysisTitle: "Expertenanalyse",
    riskExplanation: "Risikoerklärung",
    positivesTitle: "Positive Signale",
    negotiationInsight: "Verhandlungstipp",
    finalAdvice: "Endgültiger Rat",
    topRiskTitle: "Hauptrisiko",
    otherRisksTitle: "Weitere mögliche Risiken",
    otherRisksSubtitle: "Typische Schwächen dieses Motors / dieser Plattform — nicht bei diesem Fahrzeug bestätigt.",
    repairCost: "Reparaturkosten",
    knownModelIssuesTitle: "Bekannte Modellprobleme",
    aiEstimatedValue: "Geschaetzter Wert",
    priceEvalTitle: "Preisbewertung",
    evidenceTitle: "Nachweise aus MOT",
    topIssueLabel: "Hauptproblem bei diesem Auto",
    topIssueLead: "Dieser Mangel ist in der MOT-Historie dieses Fahrzeugs erfasst.",
    topIssueLeadRecurring: "Dieser Mangel wurde in {count} MOT-Tests erfasst und ist weiterhin vermerkt — er wurde nicht behoben und wird sich sehr wahrscheinlich verschlimmern.",
    notConfirmedBadge: "Bei diesem Auto nicht bestätigt",
    engineFamilyContext: "Motor- / Plattform-Kontext",
    consequencesTitle: "Bei Ignorierung",
    severityHigh: "HOHES RISIKO",
    severityMedium: "MITTLERES RISIKO",
    severityLow: "GERINGES RISIKO",
    engineAnalysisTitle: "Motoranalyse",
    engineIdentified: "Identifizierter Motor",
    engineCode: "Motorcode",
    engineKnownIssues: "Bekannte Motorprobleme",
    typicalWeaknessesTitle: "Typische Schwächen dieses Motors",
    typicalWeaknessesDisclaimer: "Dies sind bekannte potenzielle Probleme dieser Motorenfamilie — sie können, müssen aber nicht auftreten. Die tatsächlich bestätigten Mängel Ihres Wagens sehen Sie in der TÜV-Historie unten.",
    safetyRatingLabel: "Sicherheit (Crashtest)",
    safetyVerdictSafe: "Hohe Sicherheit — im Crashtest bewiesen",
    safetyVerdictAverage: "Durchschnittliche Sicherheit — ausreichend, nicht herausragend",
    safetyVerdictPoor: "Unterdurchschnittliche Sicherheit — Alternativen prüfen",
    safetyRatingSource: "Unabhängiger Euro-NCAP-Test",
    engineConfidence: "Vertrauen",
    mileageAnalysisTitle: "Kilometeranalyse",
    averageYearly: "Jaehrlicher Durchschnitt",
    milesPerYear: "Meilen/Jahr",
    mileageTrend: "Trend",
    trendStable: "Stabil",
    trendHigh: "Hohe Nutzung",
    trendLow: "Geringe Nutzung",
    trendInconsistent: "Inkonsistent",
    trendRollback: "Kilometerrueckstellung",
    trendUnknown: "Unbekannt",
    mileageFlags: "Hinweise",
    flagRollback: "Kilometerrueckstellung vermutet",
    flagLowUsage: "Sehr geringe Nutzung",
    flagHighUsage: "Hohe jaehrliche Laufleistung",
    flagInconsistent: "Kilometerinkonsistenz",
    aiMileageInsight: "Expertenanalyse der Laufleistung",
    
    // Scam Detection
    scamWarning: "PREISWARNUNG",
    scamAlertTitle: "Möglicher Betrug erkannt",
    scamAlertDesc: "Dieser Preis ist verdächtig niedrig. Könnte auf Betrug, gestohlenes Fahrzeug oder versteckte Schäden hindeuten.",
    scamRiskBadge: "HOHES BETRUGSRISIKO",
    suspiciousBadge: "VERDÄCHTIGER PREIS",
    overpricedBadge: "ÜBERTEUERT",
    fairPriceBadge: "FAIRER PREIS",
    priceRange: "Marktspanne",
    priceComparison: "Preis vs realer Wert",
    ofMarketValue: "des realen Wertes",
    
    // Vehicle Information
    vehicleInfo: "Fahrzeuginformationen",
    mileageLabel: "Kilometerstand",
    mileageVsAge: "Meilen/Jahr Durchschnitt fuer Fahrzeugalter",
    registration: "Registrierung",
    makeModel: "Marke & Modell",
    year: "Jahr",
    engine: "Motor",
    engineCode: "Motorcode",
    
    // Statistics
    totalTests: "Gesamttests",
    failedTests: "Nicht bestanden",
    failsInLast3: "Fehlgeschlagen in den letzten 3",
    dangerousDefects: "Gefährliche Mängel",
    recurringIssues: "Wiederkehrende Probleme",
    
    // Analysis sections
    aiExpertAnalysis: "Expertenanalyse",
    priceAnalysis: "Preisanalyse",
    marketMedian: "Marktmedian",
    typicalRange: "Typischer Bereich",
    priceFlag: "Preisflagge",
    knownIssues: "Bekannte Probleme dieses Modells",
    anomaliesDetected: "Anomalien erkannt",
    recurringIssuesTitle: "Wiederkehrende Probleme",
    motTestHistory: "MOT-Testhistorie",
    detectedIssuesTitle: "Erkannte Probleme",
    fullIssuesTitle: "Probleme",
    
    // Defect types
    advisory: "Hinweis",
    major: "Schwer",
    dangerous: "Gefährlich",
    recurring: "Wiederkehrend",
    
    // MOT Timeline
    noDefectsFound: "✓ Keine Mängel gefunden - sauberer Test",
    miles: "Meilen",
    expires: "Läuft ab",
    appears: "Erscheint",
    times: "mal",
    
    // Anomaly descriptions
    mileageDrop: "Kilometerstand zwischen Tests verringert - mögliche Manipulation",
    coolingSystemFlags: "Kühlsystemprobleme in der MOT-Historie erkannt",
    chainIssueSuspected: "Potenzielle Steuerketten-Probleme (häufig bei diesem Motor)",
    
    // Sources
    sources: "Quellen",
    link: "Link",

    // Loading overlay
    analyzingTitle: "Fahrzeughistorie wird analysiert...",
    loadingStep1: "MOT-Historie wird geprüft...",
    loadingStep2: "Versteckte Probleme werden erkannt...",
    loadingStep3: "Kilometerverlauf wird analysiert...",
    loadingStep4: "Motorrisiken werden identifiziert...",
    loadingStep5: "Reparaturkosten werden geschätzt...",
    loadingStep6: "Anomalien werden geprüft...",
    loadingIssuesDetected: "Mögliche Probleme erkannt...",
    loadingFinalizing: "Risikobewertung wird abgeschlossen...",
    aiWorking: "Experten prüfen...",
    aiDispatch: "Experten werden einberufen...",
    aiRoleEngine: "Motor-Experte",
    aiRolePlatform: "Plattform-Experte",
    aiRoleRisk: "Risiko-Experte",
    expertConfirmBadge: "Von 3 Experten bestätigt",
    expertConfirmTitle: "Expertenteam bestätigt",
    expertConfirmSubtitle: "3 unabhängige Experten haben Ihren Bericht geprüft",
    expertConfirmFinalScore: "Endscore",
    premiumExpertOverlayBadge: "Premium-Analyse abgeschlossen",
    premiumExpertOverlayTitle: "Experten haben die Tiefendaten geprüft",
    premiumExpertOverlaySub: "Aktualisiere deinen Worthify Score anhand der Registerdaten…",
    premiumExpertOverlayScore: "Aktualisierter Score",
    premiumExpertOverlayDone: "Tippe irgendwo, um den Bericht zu öffnen",
    premiumExpertAnnaRisk: "Anna · Risiko-Expertin",
    premiumExpertEngine: "Marcus · Motoren-Experte",
    premiumExpertPlatform: "Iris · Plattform-Expertin",
    premiumFindingWriteOff: "fand einen Totalschaden-Eintrag",
    premiumFindingTheft: "fand eine Diebstahlmeldung",
    premiumFindingMileage: "fand eine Kilometeranomalie",
    premiumFindingFinance: "fand offene Finanzierung",
    expertConfirmVerdictRefined: "Urteil durch vollständigen Expertenkonsens verfeinert",
    // Auto-generated translations (Worthify i18n batch)
    abiGroupLabel: "ABI-Gruppe",
    accessFullAssessment: "Vollständige Risikobewertung aufrufen",
    accidentCheck1: "Fahrgestell-/Strukturmängel in der MOT-Historie",
    accidentCheck2: "Ausrichtungsfehler bei Lenkung & Federung",
    accidentCheck3: "Hinweise auf größere Karosseriereparaturen in Prüfstellen",
    accidentCheck4: "Abgeglichen mit branchenweiten Unfallregistern",
    accidentChecksTitle: "Was wir geprüft haben",
    accidentModalTitle: "Unfallhistorie",
    accidentRiskHigh: "Mögliche Schadenshistorie",
    accidentRiskLow: "Keine Unfallhinweise",
    accidentScopeLabel: "Basierend auf MOT-Strukturprüfungen",
    addVinBadge: "Kostenloses Upgrade",
    addVinBadgeLowConf: "Genauigkeit verbessern",
    addVinChecking: "VIN wird geprüft…",
    addVinCopy: "Geklonte Fahrzeuge und VIN-Swap-Betrug in Sekunden erkennen. Wir vergleichen Ihre VIN mit DVLA-Marke und -Baujahr — sofort, kostenlos, keine Extrakosten.",
    addVinCopyLowConf: "Dies ist ein neueres/Nischenmodell — öffentliche Preisdaten sind dünn. Die VIN-Eingabe ermöglicht uns, die exakte Ausstattung, das Modelljahr-Listenpreis und den echten Restwert zu ermitteln.",
    addVinCta: "VIN jetzt hinzufügen",
    addVinDone: "Fertig",
    addVinError: "VIN-Überprüfung fehlgeschlagen. Bitte erneut versuchen.",
    addVinModalCopy: "Geben Sie die 17-stellige VIN vom Verkäufer ein (V5C-Fahrzeugschein oder Windschutzscheibenplakette). Wir prüfen sie gegen DVLA-Marke und -Baujahr — bei Nichtübereinstimmung wird Ihr Score auf AVOID gesetzt.",
    addVinModalTitle: "VIN verifizieren",
    addVinOkCopy: "Kein Klonsignal. Ihr Dashboard zeigt jetzt das Verifiziert-Badge.",
    addVinOkTitle: "VIN verifiziert — Marke und Baujahr stimmen überein",
    addVinScamCopy: "Score wurde auf AVOID gesetzt. Siehe rotes Banner in Ihrem Dashboard.",
    addVinScamTitle: "VIN-Abweichung erkannt — möglicherweise geklontes Fahrzeug",
    addVinSubmit: "VIN jetzt verifizieren",
    addVinTitle: "VIN gegen Zulassung verifizieren",
    addVinTitleLowConf: "VIN für genauere Bewertung hinzufügen",
    addVinUndecodableCopy: "Die öffentliche US-Datenbank listet diese VIN nicht. Üblich bei UK-Modellen — kein Warnsignal an sich.",
    addVinUndecodableTitle: "VIN gespeichert — öffentlich nicht dekodierbar",
    aiSuggested: "KI-empfohlen",
    allClear: "Alles in Ordnung",
    allDetectedIssues: "Alle erkannten Probleme",
    analyzingReassurance: "Analyse dauert in der Regel 30–60 Sekunden",
    annualCostLabel: "Jährliche Gesamtkosten",
    anomaliesShort: "Anomalien",
    assumedMiles: "angenommen 10.000 Meilen/Jahr",
    averageSoldLabel: "Durchschn. Verkaufspreis",
    averageYearlyMileage: "Durchschnittliche Jahreslaufleistung",
    avgDaysLabel: "Durchschn. Verkaufsdauer",
    avgDaysOnMarket: "durchschn. Tage auf dem Markt",
    avgYearlyMiles: "Durchschn. Meilen/Jahr",
    basedOn30yoLabel: "30-jähriger Fahrer, 5 Jahre schadenfrei",
    basedOnLastNSales: "Basierend auf den letzten 5 vergleichbaren Verkäufen",
    benefitAccident: "Unfall- & Totalschadenprüfung",
    benefitDepreciation: "Wertverlusttrendprognose",
    benefitEngine: "Motoranalyse & bekannte Probleme",
    benefitFinance: "Ausstehende Finanzierungsprüfung",
    benefitNegotiation: "Verhandlungstaktiken",
    benefitPdf: "Vollständiger druckbarer PDF-Bericht",
    benefitSimilar: "Ähnliche verkaufte Fahrzeuge (letzte 5)",
    benefitUlez: "ULEZ + 5-Jahres-Betriebskosten",
    betaDataBannerBody: "Dieses Modul verwendet derzeit heuristische Schätzungen basierend auf dem Fahrzeugprofil. Die Echtdatenintegration kommt im nächsten Release.",
    betaDataBannerTitle: "Beta-Daten — Vollversion folgt in Kürze",
    brakesLabel: "Bremsen",
    cancelLabel: "Abbrechen",
    checkNewCarCta: "Neues Fahrzeug prüfen",
    checkNewCarForOnePound: "Neues Fahrzeug für £1,00 prüfen",
    close: "Schließen",
    co2Label: "CO₂",
    confidenceLabelHigh: "Hohe Zuverlässigkeit",
    confidenceLabelLow: "Geringe Zuverlässigkeit",
    confidenceLabelMedium: "Mittlere Zuverlässigkeit",
    copyNegoError: "Kopieren fehlgeschlagen – versuchen Sie es erneut",
    copyNegoRangeLabel: "Bereich",
    copyNegoSourceLabel: "Quelle",
    copyNegoSuccess: "Argumente kopiert – fügen Sie sie in WhatsApp oder SMS ein",
    copyNegoTitle: "Worthify – Verhandlungsargumente",
    copyNegoTotalLabel: "Gesamtziel",
    copyNegotiationAria: "Verhandlungsargumente in Zwischenablage kopieren",
    copyNegotiationCta: "Verhandlungsargumente kopieren",
    copyPasteReadyLabel: "Kopieren · einfügen · senden",
    costBreakdownTitle: "Aufschlüsselung",
    costDriversTitle: "Was diese Kosten verursacht",
    costFuel: "Kraftstoff",
    costInsurance: "Versicherung",
    costService: "Service",
    costSubtitleShort: "Realistische Kosten, die Sie in den nächsten 12–24 Monaten einplanen sollten.",
    costTax: "Kfz-Steuer",
    costTierClean: "Sieht sauber aus",
    costTierHigh: "Hoch",
    costTierLow: "Niedrig",
    costTierModerate: "Moderat",
    currentRegLabel: "Aktuell",
    currentValueLabel: "Aktueller Wert",
    damageHistoryLabel: "Schadenshistorie",
    dangerousDefectsFound: "gefährliche Mängel gefunden",
    dangerousDefectsHeadline: "Sie haben gefährliche Mängel",
    dashboardAiDisclaimer: "Dies ist keine mechanische Inspektion. Führen Sie vor dem Kauf immer Ihre eigene mechanische Prüfung durch.",
    dataSourceDvla: "Quelle: DVLA VES",
    dataSourcesCopy: "DVLA, MOT, Versicherung, Marktdaten & mehr",
    dataSourcesTitle: "Wir prüfen über 50 Datenquellen",
    daysToSell: "Tage bis zum Verkauf",
    defectRecurringSuffix: "Wiederkehrend im MOT – nicht behoben, kann sich mit der Zeit verschlimmern.",
    defectThemeBrakes: "Verschleiß von Bremskomponenten",
    defectThemeCorrosion: "Korrosion / struktureller Verschleiß",
    defectThemeElectrical: "Elektrisches / Ladeproblem",
    defectThemeEmissions: "Problem mit Abgassystem",
    defectThemeExhaust: "Verschleiß des Auspuffsystems",
    defectThemeLights: "Beleuchtungsfehler",
    defectThemeOilLeak: "Motorölleck / undichte Dichtung",
    defectThemeScreen: "Windschutzscheibe / Glas",
    defectThemeSeatbelt: "Sicherheitsgurt / Rückhaltesystem-Prüfung",
    defectThemeSteering: "Verschleiß von Lenkungs-/Aufhängungsgelenken",
    defectThemeSuspension: "Verschleiß von Aufhängungskomponenten",
    defectThemeTyres: "Reifenverschleiß / Zustand",
    defectThemeWipers: "Scheibenwischer / Waschanlage",
    depreciationModalTitle: "Wertverlustp prognose",
    detectedTimesPrefix: "Erkannt",
    detectedTimesSuffix: "mal in der MOT-Historie",
    downloadingPdf: "Wird heruntergeladen…",
    dvlaRecordLabel: "DVLA-Eintrag",
    engineAnalysisShort: "Motorprobleme",
    engineCodeLabel: "Motorkennung",
    errorRateLimit: "Sie haben in kurzer Zeit zu viele Prüfungen durchgeführt. Bitte warten Sie einige Minuten und versuchen Sie es erneut.",
    errorRateLimitPayment: "Zu viele Zahlungsversuche. Bitte warten Sie einige Minuten und versuchen Sie es erneut.",
    estimatedCost: "Geschätzte Kosten",
    euroClassLabel: "Euro-Klasse",
    expectedCostBottomCaption: "Geschätzte Kosten in den nächsten 12–24 Monaten",
    expectedCostFallbackDrivers: "Die typische Belastung für dieses Fahrzeug über 12–24 Monate liegt bei etwa £{cost}, hauptsächlich verursacht durch {drivers}.",
    expectedCostFallbackGeneric: "Typische Kosten über 12–24 Monate für dieses Fahrzeug liegen bei etwa £{cost}, basierend auf Alter, Laufleistung und bekannten Modellproblemen.",
    expectedCostFallbackRange: "Realistischer Bereich £{lo}–£{hi}; vorbeugende Wartung hält Sie normalerweise am unteren Ende.",
    expectedCostFallbackTopRisk: "Typische Kosten über 12–24 Monate für dieses Fahrzeug liegen bei etwa £{cost}, wobei {issue} das Hauptproblem darstellt.",
    expectedCostHeroTitle: "Erwartete\\nzukünftige Kosten",
    expectedCostInsight: "Kosten sind moderat, aber wiederkehrende Probleme erhöhen die Wahrscheinlichkeit höherer Reparaturrechnungen.",
    expectedCostModalTitle: "Erwartete zukünftige Kosten",
    expectedCostShortLabel: "Erwartete Kosten",
    expectedCostShortTitle: "Erwartete zukünftige Investition",
    expectedCostSubtitle: "Geschätzte Kosten über die nächsten 12–24 Monate",
    expertDeepAnalysisTitle: "Ergebnisse jedes Experten",
    expertInsightLabel: "Experten-Einsicht",
    expertLeverageTitle: "Experten-Hebel",
    expertNoFindings: "Keine spezifischen Befunde von diesem Experten markiert.",
    expertNoteLabel: "Experten-Hinweis",
    expertSummaryLabel: "Zusammenfassung",
    expertTipBody: "Lassen Sie es vor dem Kauf prüfen und planen Sie die Reparatur ein.",
    expertTipLabel: "Experten-Tipp",
    expertVerifiedBadge: "Verifiziert",
    expertViewLabel: "Experten-Ansicht",
    expertiseLockedMore: "mehr in Premium",
    expertiseModalTitle: "Experten-Analyse",
    expertiseUnlockCta: "Premium freischalten",
    expertsCountBadge: "3 Experten",
    failedMotsLabel: "Durchgefallene MOTs",
    failedMotsTitle: "Durchgefallene MOT-Tests",
    failedOnce: "durchgefallener Test",
    failedPlural: "durchgefallene Tests",
    failedTestDetails: "Details zum durchgefallenen Test",
    financeClean: "Keine ausstehende Finanzierung",
    financeCleanCopy: "Kein aktives Darlehen, Leasing oder HP-Vertrag für dieses Fahrzeug erkannt. Sie können sicher fortfahren.",
    financeContextCopy: "Bei einer Bewertung um {value} sind Fahrzeuge mit ausstehender Finanzierung in ~5% der UK-Privatkaufstreitigkeiten involviert. Dieses Fahrzeug ist frei.",
    financeContextTitle: "Kontext",
    financeFound: "Ausstehende Finanzierung",
    financeFoundCopy: "Dieses Fahrzeug hat eine aktive Finanzierung — es kann nicht legal verkauft werden, bevor diese beglichen ist. Lassen Sie die Finger davon, bis der Verkäufer einen Tilgungsnachweis vorlegt.",
    financeModalTitle: "Ausstehende Finanzierung",
    financeStatusLabel: "Finanzierungsstatus",
    flaggedAnomalies: "Markierte Anomalien",
    forecastTableTitle: "Prognose",
    fromCountryLabel: "Land",
    fullPdfReport: "Vollständiger PDF-Bericht",
    fullTimeline: "Vollständige Zeitleiste",
    govUkDisclaimer: "Geschätzt basierend auf Baujahr & Kraftstoff. Bestätigen Sie unter gov.uk/check-clean-air-zone-charge",
    helpDownloadHero: "Laden Sie Ihren vollständigen Bericht herunter",
    helpDownloadSub: "Premium-Analysen + PDF — bereits bezahlt",
    helpHeroKicker: "3 unabhängige Experten",
    helpHeroTitle: "Bewerten die Fahrzeughistorie für Sie",
    helpModalTitle: "So funktioniert Worthify",
    helpSection1Copy: "Die Hauptkarte zeigt das Urteil basierend auf 3 unabhängigen Experten, die die Fahrzeughistorie bewerten.",
    helpSection1Title: "Ihr Urteil",
    helpSection2Copy: "Tippen Sie auf eine Kachel, um das vollständige Modal mit Details, Grafiken und Experten-Tipps zu öffnen. Wischen Sie nach links/rechts, um zwischen Modals zu wechseln.",
    helpSection2Title: "Jede Kachel erkunden",
    helpSection3Copy: "Eine einmalige Zahlung von £4,99 schaltet Motor-Analyse, Verhandlungsmacht, Anomalie-Check, verstecktes Finanzierungsrisiko und den vollständigen druckbaren PDF-Bericht frei.",
    helpSection3Title: "Alles freischalten",
    helpUnlockHero: "Das vollständige Bild freischalten",
    helpUnlockSub: "Motor · Verhandlung · Anomalien · Finanzierung · PDF",
    heroFailedLabel: "DURCHGEFALLEN",
    heroHpiBadgeAria: "Erfahren Sie mehr über More Than HPI Check",
    heroHpiBadgeText: "More Than HPI Check",
    heroMotPlural: "MOTS",
    heroMotSingular: "MOT",
    highRiskLabel: "HOHES RISIKO",
    hpiIncludedAi: "KI-gestützte Kauf-Insights",
    hpiIncludedFinance: "Prüfung offener Finanzierungen",
    hpiIncludedIdentity: "Fahrzeugidentitäts-Verifizierung",
    hpiIncludedImport: "Import-/Export-Status",
    hpiIncludedMarket: "Marktwert-Bewertung",
    hpiIncludedMileage: "Kilometerstand-Anomalie-Erkennung",
    hpiIncludedMot: "MOT-Verlaufsanalyse",
    hpiIncludedPdf: "PDF-Report-Export",
    hpiIncludedPlate: "Kennzeichen-Änderungsverlauf",
    hpiIncludedRisk: "Fahrzeug-Risikobewertung",
    hpiIncludedShare: "Mit Mechaniker teilen",
    hpiIncludedStolen: "Diebstahl-Prüfung",
    hpiIncludedVin: "VIN-Verifizierung",
    hpiIncludedWorthifyValue: "Worthify Value-Analyse",
    hpiIncludedWriteOff: "Versicherungs-Totalschaden (A, B, S, N)",
    ifIgnoredTitle: "Wenn ignoriert, kann dies führen zu:",
    importDetected: "Import erkannt",
    importImpactCopy: "Importierte Autos können schwerer zu versichern sein und eine langsamere Teile-Verfügbarkeit haben. Prüfen Sie die V5C für das UK-Registrierungsdatum und ggf. ein NOVA-Zertifikat (Notification of Vehicle Arrival).",
    importImpactTitle: "Was das bedeutet",
    importModalTitle: "Import-Verlauf",
    importTypeLabel: "Import-Typ",
    inLabel: "In",
    includedTitle: "Alles, was enthalten ist",
    independentBadge: "Unabhängig",
    insuranceDisclaimer: "Geschätzte Gruppe. Ihre tatsächliche Prämie hängt von Alter, Postleitzahl, Schadenverlauf und Selbstbeteiligung ab.",
    insuranceGroupModalTitle: "Versicherungsgruppe",
    issuesFound: "Probleme gefunden",
    knownIssuesTitle: "Bekannte Motorprobleme",
    lastChangeLabel: "Letzte Änderung",
    legalAllRights: "Alle Rechte vorbehalten.",
    legalBackToHome: "Zurück zu Worthify",
    legalLastUpdated: "Zuletzt aktualisiert",
    legalNavCookies: "Cookie-Richtlinie",
    legalNavAccessibility: "Barrierefreiheit",
    legalNavPrivacy: "Datenschutzerklärung",
    legalNavTerms: "Nutzungsbedingungen",
    leverageLabel: "Verhandlungsspielraum",
    lifeRemaining: "Restlebensdauer",
    lockedPremiumCopy: "Entsperren Sie diesen Bereich zusammen mit dem vollständigen PDF-Report und 14 weiteren Premium-Checks für £4.99.",
    lockedPremiumTitle: "Premium-Insight",
    looksLike: "Sieht aus wie",
    looksLikeA: "Sieht aus wie ein",
    lowRiskLabel: "NIEDRIGES RISIKO",
    marketGaugeAskingLabel: "Angebot",
    marketGaugeMarketLabel: "Markt",
    marketGaugeVsMarket: "vs Markt",
    marketGauge_FAIR: "Fairer Wert",
    marketGauge_SIGNIFICANTLY_OVER: "Deutlich überteuert",
    marketGauge_SLIGHTLY_OVER: "Leicht überteuert",
    marketGauge_UNDERPRICED: "Unterpreisig",
    maybeLaterCta: "Vielleicht später",
    mediumRiskLabel: "MITTEL",
    methodologyConfHighHint: "MOT-Verlauf, VIN und Kilometerstand vollständig vorhanden — Multi-KI-Übereinstimmung bei den Ergebnissen.",
    methodologyConfLowHint: "Begrenzte öffentliche Daten für dieses Fahrzeug. Score ist heuristisch — physische Inspektion dringend empfohlen.",
    methodologyConfMedHint: "Einige Datenpunkte fehlen (z. B. VIN oder vollständiger MOT). Score ist zuverlässig, aber nicht maximal.",
    methodologyConfidence: "Vertrauenswürdigkeit: {level}",
    methodologyDisclaimer: "Worthify aggregiert offizielle DVSA-, DVLA- und NHTSA-Daten mit einem 3-KI-Konsens-System — echtes More Than HPI Check zu einem Bruchteil des Preises. Es ersetzt keine physische Inspektion. Buchen Sie immer Ihre eigene mechanische Prüfung vor dem Kauf.",
    methodologyDisclaimerTitle: "Unabhängige Inspektion weiterhin empfohlen",
    methodologyIntro: "Worthify kombiniert öffentliche UK-Regierungsdaten mit einem 3-Modell-KI-Konsens, um das Risiko beim Kauf eines bestimmten Gebrauchtwagens abzuschätzen. Hier sehen Sie genau, woher jedes einzelne Informationsstück stammt.",
    methodologySourcesTitle: "Datenquellen",
    methodologyTitle: "So funktioniert Worthify",
    mileageAnomalyBadge: "ANOMALY",
    mileageAnomalyCopy: "Kilometerstandanomalie erkannt",
    mileageConsistent: "Kilometerstand sieht konsistent aus",
    mileageHeroTitle: "Kilometerstand-\\nanalyse",
    mileageInsightAnomaly: "Der Kilometerverlauf zeigt Unstimmigkeiten. Prüfen Sie die Wartungsunterlagen sorgfältig.",
    mileageInsightConsistent: "Der Kilometerstand sieht konsistent mit Alter und Historie des Fahrzeugs aus.",
    mileageInsightTitle: "Kilometerstand-Bewertung",
    mileageStableBadge: "STABLE",
    monthlyCostLabel: "Pro Monat",
    moreHpiEveryoneBody: "Entwickelt für alltägliche Autokäufer, Fahranfänger, Familien, Enthusiasten und erfahrene Autofahrer gleichermaßen. Ob Sie Mechaniker sind oder Ihr erstes Auto kaufen – Worthify hilft Ihnen zu verstehen, was die Daten tatsächlich bedeuten, bevor Sie Ihr Geld ausgeben.",
    moreHpiEveryoneTitle: "Für alle gemacht",
    moreHpiFooterChips: "🛡 More Than HPI Check · KI-Analyse · Marktbewertung · Premium-Insights",
    moreHpiFooterTagline: "Fahrzeug-Intelligence, nicht nur Fahrzeughistorie.",
    moreHpiFooterTrust: "Gestützt auf vertrauenswürdige UK-Fahrzeug-Intelligence und offizielle Fahrzeugdatenquellen.",
    moreHpiHeaderSub: "Die fortschrittlichste Fahrzeug-Intelligence-Plattform des Vereinigten Königreichs – entwickelt, um Ihnen vor dem Kauf die richtige Entscheidung zu ermöglichen.",
    moreHpiHeaderTitle: "Warum Worthify anders ist",
    moreHpiHeroBody: "Wir kombinieren vertrauenswürdige UK-Daten, Marktbewertung und KI-Analyse, um Ihnen klare Antworten, einfache Erklärungen und echtes Vertrauen zu geben.",
    moreHpiHeroHighlight: "More Than HPI Check",
    moreHpiHeroPost: ".",
    moreHpiHeroPre: "Worthify ist ",
    moreHpiIncludedTitle: "Premium-Fahrzeug-Intelligence inklusive",
    moreHpiIntroBody: "More Than HPI Check – Worthify kombiniert vertrauenswürdige UK-Fahrzeug-Intelligence, Marktbewertung und KI-gestützte Analyse in einem leicht verständlichen Bericht.",
    moreHpiIntroLead: "Worthify zeigt nicht nur Fahrzeugdaten – es erklärt sie.",
    moreHpiModalSubtitle: "Die beste Preis-Leistungs-Fahrzeug-Intelligence-Plattform des Vereinigten Königreichs",
    moreHpiModalTitle: "Warum ist Worthify anders?",
    moreHpiMultilingualBody: "Fahrzeugberichte und Erklärungen sind in mehreren Sprachen verfügbar und machen Fahrzeugprüfungen für alle im Vereinigten Königreich zugänglicher.",
    moreHpiMultilingualTitle: "Mehrsprachiger Support",
    moreHpiNoKnowBody: "Worthify übersetzt komplexe Fahrzeugdaten in einfache Erklärungen, die jeder verstehen kann. Verstehen Sie, was die Daten bedeuten, bevor Sie Ihr Geld ausgeben.",
    moreHpiNoKnowTitle: "Keine Autokenntnisse erforderlich",
    moreHpiSourcesLine: "Wir nutzen vertrauenswürdige UK-Datenquellen wie DVLA, DVSA und führende Fahrzeugdatenanbieter.",
    moreHpiValueBody: "Worthify liefert erweiterte Fahrzeug-Intelligence, Marktbewertung, MOT-Analyse und KI-gestützte Kaufempfehlungen für nur ",
    moreHpiValueBodyEnd: ".",
    moreHpiValueKicker: "Warum über £30 bezahlen?",
    moreHpiWhy30Body: "Worthify kombiniert erweiterte Fahrzeug-Intelligence, Marktbewertung und KI-gestützte Analyse in einem erschwinglichen Bericht. Kein Fachjargon. Nur klare Antworten, denen Sie vertrauen können.",
    moreHpiWhy30Title: "Warum über £30 für einen traditionellen Fahrzeugbericht bezahlen?",
    moreLockedHeadline: "3 Premium-Analysen gesperrt",
    motConfirmedBadge: "MOT-bestätigt",
    motExpiryLabel: "MOT läuft ab",
    motHistoryLabel: "MOT-Historie",
    motHistoryTitle: "MOT-Historie",
    navExpertise: "Expertise",
    navMore: "Mehr",
    navOverview: "Übersicht",
    navPremium: "Premium",
    navReports: "Berichte",
    navSearch: "Neue Suche",
    navVehicle: "Fahrzeug",
    negoAskingLabel: "Angebotspreis",
    negoBulletComfortPrice: "Ein angemessenes Angebot unter Berücksichtigung dieses Risikos liegt bei etwa £{price}.",
    negoBulletKnownIssues: "Dieses Modell hat {n} dokumentierte Schwachstellen – sprechen Sie diese bei der Besichtigung an.",
    negoBulletTopRisk: "Größtes Risiko: {issue} – Reparatur typischerweise £{lo}–£{hi}.",
    negoBulletTotalExposure: "Gesamtes Reparaturrisiko: £{lo}–£{hi} in den nächsten 24 Monaten.",
    negoEmptyCopy: "Keine starken Verhandlungspunkte erkannt – das technische und Marktprofil dieses Autos sieht sauber aus. Ein festes, aber faires Angebot zum Angebotspreis (oder 2–3 % darunter) ist angemessen.",
    negoFairWithRepairsLabel: "Fair mit Reparaturen",
    negoMarketValueLabel: "Marktwert",
    negoScamBullet1: "Überprüfen Sie die Identität des Verkäufers persönlich vor jeder Zahlung",
    negoScamBullet2: "Führen Sie einen DVLA-/Historien-Check der VIN durch, bevor Sie Geld überweisen",
    negoScamBullet3: "Lehnen Sie jede Anfrage nach Krypto-/Geschenkkarten-/Überweisungszahlung ab",
    negoScamCopy: "Der Angebotspreis (£{asking}) liegt weit unter dem tatsächlichen Marktwert dieses Autos (£{value}). Dieses Muster signalisiert fast immer ein gefälschtes Inserat, ein gestohlenes Fahrzeug, nicht offengelegte Schäden oder einen Treuhandbetrug. Zahlen Sie keine Anzahlung, teilen Sie keine Dokumente und organisieren Sie keinen Transport. Melden Sie das Inserat und suchen Sie weiter.",
    negoScamHeader: "Betrug erkannt",
    negoScamTitle: "Nicht verhandeln — sofort abbrechen",
    negoScamVinCopy: "Die VIN des Verkäufers dekodiert zu {vinMake} {vinYear}, aber die DVLA-Zulassung zeigt {dvlaMake} {dvlaYear}. Das ist ein klassisches Signal für ein geklontes Fahrzeug / VIN-Tausch. Zahlen Sie keine Anzahlung und teilen Sie keine Dokumente.",
    negoScamVinTitle: "VIN stimmt nicht mit der Zulassung überein — sofort abbrechen",
    negoSuspiciousAsk1: "Warum liegt der Preis unter Marktwert? (Jobverlust / Schnellverkauf / versteckter Schaden?)",
    negoSuspiciousAsk2: "Vollständigen Historien-Check + V5C-Fahrzeugbrief + vollständige Servicenachweise vor jeder Anzahlung anfordern",
    negoSuspiciousAsk3: "Persönlich besichtigen — niemals per Krypto / Überweisung / Gutscheinkarte zahlen",
    negoSuspiciousCopy: "Der Preis von £{asking} liegt bereits £{gap} unter dem Marktwert dieses Fahrzeugs (£{market}). Selbst nach den voraussichtlichen Reparaturen von £{rLo}–£{rHi} läge ein fairer Preis bei etwa £{fair}. Der Verkäufer bietet es für weniger an. Finden Sie heraus, warum, bevor Sie irgendetwas zahlen.",
    negoSuspiciousKicker: "Preis bereits unter Marktwert",
    negoSuspiciousTitle: "Nicht runterhandeln — erst verifizieren",
    negotiationCumulativeLabel: "Kumulierte Käuferersparnis",
    negotiationHeadline: "Verhandlungsziel",
    negotiationItemTarget: "Empfohlenes Angebot",
    negotiationShort: "Verhandlungsbasis",
    newSearchCopy: "Starten Sie eine neue Analyse für eine andere Zulassung. Die aktuelle Analyse bleibt gespeichert.",
    newSearchPaymentCopy: "Jede Fahrzeugprüfung ist eine einmalige Zahlung von £1, die alle Premium-Analysen für dieses Fahrzeug freischaltet.",
    newSearchPaymentTitle: "Neue Analyse erfordert neue Zahlung",
    newSearchTitle: "Neue Fahrzeugprüfung",
    noAnomalies: "Keine Anomalien in der MOT-Historie erkannt.",
    noFailedDetails: "Detaillierte Mängeldaten für dieses Fahrzeug nicht verfügbar.",
    noImportFlag: "UK- / EU-Markt",
    noMajorRisks: "Keine größeren Risiken",
    noMotDetails: "Detaillierter MOT-Verlauf nicht verfügbar.",
    noPriceEvalCopy: "Fügen Sie einen Zielpreis hinzu, um eine Preisbewertung zu erhalten.",
    noRecurring: "Keine wiederkehrenden Mängel in der MOT-Historie gefunden.",
    noVinForImport: "Fügen Sie eine VIN auf der Startseite hinzu für eine vollständige Herkunftsprüfung.",
    nowLabel: "Jetzt",
    offAskingLabel: "unter Angebotspreis",
    originLabel: "Herkunft",
    ourVerdictLabel: "Unser Urteil",
    outOfLabel: "von",
    ownerLabel: "Halter",
    ownerPlural: "eingetragene Halter",
    ownerSingular: "eingetragener Halter",
    ownersAverageCopy: "Durchschnittliche Halterdauer — keine Warnsignale, aber fragen Sie nach Servicenachweisen.",
    ownersCountLabel: "Gesamthalter",
    ownersFewCopy: "Wenige Halter — bedeutet meist, dass das Fahrzeug gut gepflegt wurde.",
    ownersInsightTitle: "Halter-Einblick",
    ownersManyCopy: "Viele Halter in kurzer Zeit können auf Probleme hinweisen — genau prüfen.",
    ownersModalTitle: "Vorherige Halter",
    ownersTimelineTitle: "Halter-Verlauf",
    ownersV5CFreshNote: "Ausgestellt innerhalb der letzten 12 Monate — weist typischerweise auf einen kürzlichen Halterwechsel hin (DVLA).",
    ownersV5CLabel: "Letzter V5C ausgestellt",
    ownersV5COldNote: "Gleiches V5C-Dokument noch aktiv — keine kürzliche eingetragene Übertragung.",
    paymentCancelledBody: "Es wurde keine Abbuchung vorgenommen. Sie können es jederzeit erneut versuchen.",
    paymentCancelledTitle: "Zahlung abgebrochen",
    paymentTimeoutError: "Die Zahlung dauert länger als gewöhnlich. Falls Sie belastet wurden, kontaktieren Sie bitte support@worthify.co.uk unter Angabe der Sitzungs-ID: ",
    pdfDownloadCopy: "Ihr vollständiger PDF-Bericht ist fertig.",
    pdfDownloadNow: "Vollständigen Bericht herunterladen",
    pdfDownloadTitle: "Laden Sie Ihren vollständigen Bericht herunter",
    pdfFullReportLabel: "Vollständiger Bericht",
    pdfIncludesTitle: "Inhalt",
    pdfReportLabel: "Vollständiger PDF-Bericht",
    pdfReportValue: "Download",
    pdfUnlockCopy: "Erhalten Sie die vollständige Aufschlüsselung, Experteneinschätzungen und Kostenanalyse als PDF.",
    pdfUnlockCta: "Für £4,99 freischalten",
    pdfUnlockTitle: "Vollständigen Bericht freischalten",
    pdfUnlockedLabel: "Freigeschaltet",
    perMonth: "pro Monat",
    perYear: "pro Jahr",
    perYearLabel: "pro Jahr",
    policeRegisterLabel: "Polizeiregister",
    preCheckoutBadge: "Kauf bestätigen",
    preCheckoutBenefitMot: "MOT-Risikoanalyse",
    preCheckoutBenefitRecall: "Rückruf- & Totalschadenprüfung",
    preCheckoutBenefitShare: "PDF + mit Mechaniker teilen",
    preCheckoutBenefitValuation: "Marktbewertung",
    preCheckoutConsent: "Ich stimme der sofortigen Lieferung zu und verstehe, dass ich mein 14-tägiges Widerrufsrecht verliere.",
    preCheckoutNoSub: "Kein Abo · Keine automatische Verlängerung",
    preCheckoutOneTime: "Einmalige Zahlung",
    preCheckoutPayCta: "£{n} mit Stripe zahlen",
    preCheckoutPdfProductName: "Premium Worthify Report (PDF + 15 Module)",
    preCheckoutRedirecting: "Weiterleitung zu Stripe…",
    preCheckoutTickToContinue: "Kästchen ankreuzen, um fortzufahren",
    preCheckoutTotal: "Gesamt",
    preCheckoutTrustLine: "Gesichert durch Stripe · Kartendaten berühren Worthify nie · Beleg wird automatisch gesendet",
    preCheckoutVerdictProductName: "Worthify Basic Verdict",
    preCheckoutWarningBody: "Ihr Bericht wird sofort in Ihrem Browser geliefert, sobald die Zahlung erfolgreich ist. Mit der Bestätigung stimmen Sie zu, die Leistung jetzt zu beginnen, und verzichten auf Ihr 14-tägiges Widerrufsrecht gemäß den UK Consumer Contracts Regulations 2013.",
    preCheckoutWarningTitle: "Sofortige digitale Lieferung",
    premiumAnalysesBadge: "Premium-Analysen",
    premiumAnalysesLocked: "Premium-Analysen gesperrt",
    premiumAnalysesTitle: "Alle Analysen",
    premiumEstimateTitle: "Jährliche Versicherungsschätzung",
    premiumHomeCopy: "Tippen Sie auf eine Kachel, um die vollständige Analyse zu öffnen. Tippen Sie auf Übersicht, um zum Hauptdashboard zurückzukehren.",
    premiumHomeFooter: "Tippen Sie unten auf Übersicht, um zum Hauptdashboard zurückzukehren",
    premiumHomeKicker: "Premium · Freigeschaltet",
    premiumHomeTitle: "Alle 15 Premium-Analysen",
    premiumLabel: "Premium",
    premiumLockedTag: "Premium · Gesperrt",
    premiumPositioningSub: "Finanzierung · Gestohlen · Totalschaden · VIN · KI-Insights · Marktbewertung",
    premiumPositioningTagline: "More Than HPI Check",
    premiumRangeLabel: "Typische Versicherung",
    premiumUnlockedTag: "Premium · Freigeschaltet",
    priceCheckLabel: "Preisprüfung",
    priceFair: "Preis wirkt fair",
    priceFairBig: "FAIRER PREIS",
    priceNoData: "Keine Preisprobleme erkannt",
    priceOptionalHint: "Optional · schaltet Preisprüfung frei",
    priceOverpriced: "Preis wirkt hoch",
    priceOverpricedBig: "ÜBERTEUERT",
    priceScamTitle: "Preisprüfung",
    priceSubtitleDetected: "Basierend auf Marktdaten & Historie.",
    priceSuspicious: "Preis wirkt verdächtig",
    priceSuspiciousBig: "VERDÄCHTIGER PREIS",
    pricingFooterLine1: "Starten Sie mit einer kostenlosen Empfehlung.",
    pricingFooterLine2: "Upgraden Sie nur, wenn Sie tiefere Einblicke und Premium-Fahrzeugintelligenz wünschen.",
    pricingTransparencySub: "Drei Stufen. Zahlen Sie nur für die Tiefe, die Sie brauchen.",
    pricingTransparencyTitle: "Einfache Preise. Komplette Transparenz.",
    proceedToPaymentCta: "Weiter zur Zahlung — £4.99",
    rangeLabel: "Bereich",
    realisticRangeLabel: "Realistischer Bereich",
    recentSalesTitle: "Kürzliche vergleichbare Verkäufe",
    recurringAcross: "über",
    recurringIgnoredBadge: "Mehrere Zyklen ignoriert",
    recurringIssuesLabel: "Wiederkehrende Probleme",
    recurringIssuesTimelineTitle: "Zeitleiste wiederkehrender Probleme",
    recurringYearsLabel: "Jahre",
    regPlaceholder: "z.B. AB12CDE",
    registrationLabel: "Zulassung",
    riskSuffix: "RISIKO",
    runningCostsDisclaimer: "Schätzungen basierend auf britischen Durchschnittswerten. Die tatsächlichen Kosten variieren je nach Fahrstil, Standort und Versicherer.",
    runningCostsModalTitle: "Betriebskosten",
    safetyAxisAdult: "Erwachsene Insassen",
    safetyAxisAssist: "Sicherheitsassistenz",
    safetyAxisChild: "Kinder-Insassen",
    safetyAxisPedestrian: "Fußgänger / VRU",
    safetyBreakdownCopy: "Wie dieses Fahrzeug in den vier Euro NCAP-Testbereichen abschneidet.",
    safetyBreakdownTitle: "Vollständige Sicherheitsaufschlüsselung",
    safetyBreakdownUnlockCta: "Vollständige Aufschlüsselung freischalten – £4,99",
    safetyCardTitle: "Sicherheit (Crashtest)",
    safetyCopy1: "Schwacher Aufprallschutz – 1★ Euro NCAP. Erhebliche Sicherheitsbedenken bei realen Unfällen; erwägen Sie nach Möglichkeit eine sicherere Alternative.",
    safetyCopy2: "Schwacher Aufprallschutz – 2★ Euro NCAP. Unterhalb moderner Sicherheitsstandards, mit messbarem Risiko bei Front- und Seitenaufprallen.",
    safetyCopy3: "Durchschnittlicher Aufprallschutz – 3★ Euro NCAP. Akzeptabel für seine Zeit, aber neuere Konkurrenten bieten spürbar besseren Insassen- und Fußgängerschutz.",
    safetyCopy4: "Starke Crashtest-Leistung – 4★ Euro NCAP. Ein solides Sicherheitspaket, das bei modernen Aufpralltests gut abschneidet.",
    safetyCopy5: "Erstklassiger Aufprallschutz – volle 5★ Euro NCAP. Zu den sichersten Fahrzeugen seiner Zeit, mit starkem Schutz für Erwachsene, Kinder und Fußgänger.",
    safetyGoodCopy: "Starke Crashtest-Leistung für seine Zeit.",
    safetyHeadline1: "Schwache Sicherheit",
    safetyHeadline2: "Geringe Sicherheit",
    safetyHeadline3: "Durchschnittliche Sicherheit",
    safetyHeadline4: "Starke Sicherheit",
    safetyHeadline5: "Hervorragende Sicherheit",
    safetyNoDataCopy: "Keine Euro NCAP-Bewertung für dieses Modell verfügbar.",
    safetyOkCopy: "Durchschnittliche Crashtest-Leistung für seine Zeit.",
    safetyPoorCopy: "Unterdurchschnittliche Crashtest-Leistung.",
    safetyTileAverage: "Durchschnittliche Crashtest-Sicherheit für seine Zeit",
    safetyTileNoData: "Keine Euro NCAP-Daten",
    safetyTilePoor: "Unterdurchschnittlicher Aufprallschutz",
    safetyTileStrong: "Starke Sicherheit – in Crashtests bewiesen",
    scamAllClearCopy: "MOT-Historie und Kilometerstand wirken konsistent.",
    scamAllClearTitle: "Keine Warnzeichen erkannt",
    scamCheck1: "Kilometerstand-Konsistenz über MOT-Tests hinweg",
    scamCheck2: "Historie gefährlicher Mängel",
    scamCheck3: "Wiederkehrende oder ignorierte Mängel",
    scamCheck4: "Lange MOT-Lücken oder verdächtige Muster",
    scamChecklistTitle: "Was wir geprüft haben",
    scamDetectionLabel: "Betrugs-Checks",
    scamFlaggedBadge: "Markiert",
    scamSafeBadge: "Keine Warnzeichen",
    scamSafeValue: "Sauber",
    scoreBadgeBad: "SCHLECHT",
    scoreBadgeGood: "GUT",
    scoreBadgeOk: "DURCHSCHNITTLICH",
    scoreDisclaimer: "Bewertungen basieren auf verfügbaren Daten und sind keine Garantie für den Fahrzeugzustand.",
    scoreExpertsUnlockCta: "Vollständige Expertenanalyse freischalten – £4,99",
    scoreScaleAverage: "Durchschnittlich",
    scoreScaleExcellent: "Hervorragend",
    scoreScaleGood: "Gut",
    scoreScalePoor: "Schlecht",
    scoreScaleTitle: "Bewertungsskala",
    scoreScaleVeryPoor: "Sehr schlecht",
    scoreScamHeader: "Betrug erkannt",
    scoreScamPriceCopy: "Der Angebotspreis liegt weit unter dem realen Marktwert dieses Fahrzeugs. Dies deutet fast immer auf ein gefälschtes Inserat, ein gestohlenes Fahrzeug oder einen Treuhand-Betrug hin – Bewertung auf 25/100 gesetzt (VERMEIDEN).",
    scoreScamPriceTitle: "Angebotspreis weit unter dem realen Marktwert",
    scoreScamVinCopy: "Die VIN des Verkäufers dekodiert zu einer anderen Marke oder einem anderen Baujahr als die DVLA-Registrierung. Dieses Muster deutet auf ein geklontes Fahrzeug oder VIN-Tausch-Betrug hin – Bewertung auf 25/100 gesetzt (VERMEIDEN).",
    scoreScamVinTitle: "VIN stimmt nicht mit der Zulassung überein",
    scoreShortBad: "Hohes Risikoprofil – planen Sie eine sorgfältige Inspektion, bevor Sie sich verpflichten.",
    scoreShortGood: "Solide Historie – die Zahlen unterstützen einen selbstbewussten Kauf.",
    scoreShortOk: "Gemischte Signale – mit Verhandlung machbar, aber beachten Sie die wiederkehrenden Probleme.",
    seeFullExpertAnalysis: "Vollständige Expertenanalyse ansehen",
    seenIn: "Gesehen in",
    seenInMotPrefix: "MOT-bestätigt",
    sellerScriptTitle: "Was Sie dem Verkäufer sagen sollten",
    severityAdvisory: "Hinweis",
    severityDangerous: "Gefährlich",
    severityFailure: "Durchgefallen",
    severityMajor: "Schwerwiegend",
    severityMinor: "Geringfügig",
    severityNote: "Notiz",
    shareReportCopied: "Link kopiert",
    shareReportCopyManual: "Diesen Link kopieren:",
    shareReportMessage: "Sehen Sie sich diesen Fahrzeugbericht von Worthify an",
    shareWithMechanicBadge: "Zweite Meinung",
    shareWithMechanicCopied: "Link kopiert – an Ihren Mechaniker senden",
    shareWithMechanicCopy: "Senden Sie das Kennzeichen an einen vertrauenswürdigen Mechaniker oder Freund. Sie erhalten einen Link, um die Ergebnisse vor Ihrer Kaufentscheidung zu überprüfen.",
    shareWithMechanicCopyError: "Kopieren fehlgeschlagen. Lange drücken, um manuell zu teilen.",
    shareWithMechanicCta: "Link teilen",
    shareWithMechanicKicker: "Zweite Meinung? Senden Sie diesen Bericht an einen vertrauenswürdigen Mechaniker.",
    shareWithMechanicMessage: "Hey – was hältst du von diesem Auto? Worthify hat es für mich analysiert:",
    shareWithMechanicTitle: "Diesen Bericht mit Ihrem Mechaniker teilen",
    similarSoldDisclaimer: "Preise aus britischen Kleinanzeigen für dieselbe Marke/Modell und Baujahr entnommen.",
    similarSoldModalTitle: "Ähnliche verkaufte Fahrzeuge",
    simpleExplanationCardSub: "Eine 60-Sekunden-Antwort, die jeder versteht",
    simpleExplanationCardTitle: "Soll ich das kaufen?",
    simpleExplanationDisclaimer: "Diese Zusammenfassung dient nur zur Orientierung – lassen Sie das Auto vor dem Kauf immer von einem qualifizierten Mechaniker persönlich überprüfen.",
    simpleExplanationEmpty: "Die Analyse wird noch vorbereitet. Versuchen Sie es gleich noch einmal.",
    simpleExplanationHeadline: "Soll ich das kaufen?",
    simpleExplanationKicker: "Verständlich erklärt",
    simpleExplanationLockedBadge: "Gesperrt – mit Premium freischalten",
    simpleExplanationLockedTitle: "Vollständige Aufschlüsselung",
    simpleExplanationSubhead: "Eine jargonfreie Antwort basierend auf der vollständigen Worthify-Analyse – so geschrieben, dass jeder sie versteht.",
    simpleExplanationTitle: "Verständliche Zusammenfassung",
    simpleExplanationUnlockCta: "Vollständige Erklärung freischalten – Premium",
    simpleExplanationVerdictTitle: "Das ist Sache",
    socialProofCopy: "Genutzt von über 50.000 britischen Autokäufern",
    sourceAiDesc: "Drei unabhängige große Sprachmodelle analysieren die Daten parallel. Der Worthify Score verwendet den Median ihrer Schätzungen, sodass eine einzelne Halluzination das Ergebnis nicht verzerren kann.",
    sourceDvsaDesc: "Offiziell von der britischen Regierung – jedes MOT-Testergebnis, Hinweise und gefährliche Mängel.",
    sourceNhtsaDesc: "Öffentliche US-Regierungsdatenbank zur Dekodierung der VIN des Verkäufers und Erkennung von Fahrzeugklonen.",
    structuralFlagsLabel: "Strukturelle Warnungen",
    suggestedReductionKicker: "Empfohlene Preisreduktion",
    suspiciousPriceCtaHint: "Tippen, um zu sehen, warum das wichtig ist →",
    suspiciousPriceKicker: "Verdächtig niedriger Angebotspreis",
    suspiciousPriceShort: "Der Preis von £{asking} entspricht nur {pct}% des Marktwerts (£{market}). Vor Zahlung überprüfen.",
    swipeDownHint: "Tipp: Nach unten wischen zum Schließen",
    testRecorded: "Test aufgezeichnet",
    testedIn: "Geprüft in",
    testsRecorded: "Tests aufgezeichnet",
    theftCheck1: "Police National Computer (PNC)",
    theftCheck2: "DVLA-Diebstahlregister",
    theftCheck3: "MIAFTR (Versicherungsbranche)",
    theftCheck4: "Häfen / Import-Warnungen",
    theftChecksTitle: "Überprüfte Register",
    theftClean: "Kein Diebstahleintrag",
    theftCleanCopy: "Kein Eintrag im Police National Computer oder DVLA-Diebstahlregister gefunden. Dieses Fahrzeug erscheint legitim.",
    theftFlagged: "Als gestohlen gemeldet",
    theftFlaggedCopy: "Dieses Fahrzeug ist als gestohlen registriert. NICHT fortfahren – Polizei unter 101 kontaktieren.",
    theftModalTitle: "Diebstahl & Gestohlenes-Check",
    tierBestValue: "BESTES ANGEBOT",
    tierFreeBasicInfo: "Grundlegende Fahrzeuginformationen (Marke · Modell · Baujahr)",
    tierFreeBuyRec: "Kaufempfehlung",
    tierFreeCallout: "Perfekt, um zu wissen, ob sich dieses Auto näher anzusehen lohnt.",
    tierFreeF1: "Worthify Kaufempfehlung (Meiden · Vorsicht · Gutes Angebot)",
    tierFreeFooter: "Erfahren Sie, ob das Fahrzeug einen genaueren Blick verdient.",
    tierFreeFooterQ: "Sollte ich dieses Auto überhaupt in Betracht ziehen?",
    tierFreeIntro: "Erhalten Sie sofort eine Empfehlung, bevor Sie auch nur einen Penny ausgeben.",
    tierFreeIntro2: "Erhalten Sie eine schnelle Empfehlung, bevor Sie einen Penny ausgeben.",
    tierFreeLabel: "KOSTENLOSE PRÜFUNG",
    tierFreeMot: "MOT-Status (Bestanden / Durchgefallen / Aktiv)",
    tierFreeName: "Sofortige Entscheidungshilfe",
    tierFreeTax: "Steuerstatus",
    tierNewPill: "NEU",
    tierPremAiAdv: "KI-Kaufeinblicke (Erweitert)",
    tierPremEverythingStd: "Alles aus der Standard-Prüfung",
    tierPremF1: "Prüfung offener Finanzierungen",
    tierPremF10: "Worthify Wertanalyse (Premium-Datensatz)",
    tierPremF11: "KI-gestützte Kaufeinblicke (Premium-Modell)",
    tierPremF12: "Premium-PDF-Bericht (herunterladbar)",
    tierPremF2: "Prüfung auf gestohlene Fahrzeuge",
    tierPremF3: "Versicherungsschadenkategorien (A, B, S, N)",
    tierPremF4: "VIN-Verifizierung (tiefgehend)",
    tierPremF5: "Fahrzeugidentitätsprüfung",
    tierPremF6: "Kilometerstand-Anomalieerkennung",
    tierPremF7: "Fahrzeugrisikobewertung",
    tierPremF8: "Kennzeichenwechsel-Verlauf",
    tierPremF9: "Import-/Exportstatus",
    tierPremFinance: "Prüfung offener Finanzierungen",
    tierPremIdentity: "Fahrzeugidentitätsprüfung",
    tierPremImport: "Import-/Exportprüfung",
    tierPremMarket: "Marktbewertung",
    tierPremMileage: "Kilometerstand-Anomalieerkennung",
    tierPremMotHistory: "Detaillierte MOT-Historie",
    tierPremMulti: "Mehrsprachige Unterstützung",
    tierPremNego: "Verhandlungsvorteil",
    tierPremPdf: "PDF-Bericht herunterladen",
    tierPremPlate: "Kennzeichenwechsel-Verlauf",
    tierPremRiskAdv: "Risikobewertung (Erweitert)",
    tierPremShare: "Mit Mechaniker teilen",
    tierPremStolen: "Prüfung auf gestohlene Fahrzeuge",
    tierPremVin: "VIN-Verifizierung",
    tierPremWorthifyValue: "Worthify-Wert (Premium-Daten)",
    tierPremWriteOff: "Versicherungsschadenprüfung",
    tierPremiumBadge: "Bestes Preis-Leistungs-Verhältnis",
    tierPremiumCallout: "Alles, was Sie brauchen, bevor Sie Tausende für ein Fahrzeug ausgeben.",
    tierPremiumFooter: "Alles, was Sie brauchen, bevor Sie Tausende für ein Fahrzeug ausgeben.",
    tierPremiumFooterQ: "Welche Risiken sollte ich vor dem Kauf kennen?",
    tierPremiumIncludes: "Alles aus Standard, plus erweiterte Fahrzeuginformationen:",
    tierPremiumIntro: "More Than HPI Check.",
    tierPremiumIntro2: "Erhalten Sie umfassende Fahrzeuginformationen, Marktwert und Risikoanalyse.",
    tierPremiumLabel: "PREMIUM-PRÜFUNG",
    tierPremiumName: "More Than HPI Check",
    tierStandardCallout: "Verstehen Sie, warum dies ein guter Kauf oder ein riskanter sein könnte.",
    tierStandardFooter: "Verstehen Sie, was die Fahrzeugdaten tatsächlich bedeuten.",
    tierStandardFooterQ: "Warum ist dies ein guter oder schlechter Kauf?",
    tierStandardIntro: "Schalten Sie die vollständige Worthify-Analyse frei.",
    tierStandardIntro2: "Schalten Sie die vollständige Worthify-Analyse frei und verstehen Sie die Risiken.",
    tierStandardLabel: "STANDARD-PRÜFUNG",
    tierStandardName: "Verstehen Sie die Entscheidung",
    tierStdAiExpl: "KI-Analyse & Erklärungen",
    tierStdEverythingFree: "Alles aus der kostenlosen Prüfung",
    tierStdF1: "Vollständiger Worthify Buy Score (0–100)",
    tierStdF10: "Worthify Marktbewertung",
    tierStdF2: "Erweiterte 3-KI-Konsens-Einblicke",
    tierStdF3: "Detaillierte MOT-Analyse & Ausfallmuster",
    tierStdF4: "Fahrzeugstärken & -schwächen",
    tierStdF5: "Motoranalyse & Cluster-Probleme",
    tierStdF6: "Expertenansichten (Mechaniker · Händler · Ökonom)",
    tierStdF7: "Verhandlungshebel & Reparaturschätzungen",
    tierStdF8: "Crashtest / Sicherheitsanalyse",
    tierStdF9: "Mit Mechaniker teilen",
    tierStdInitialRisk: "Erste Risikobewertung",
    tierStdMot: "Detaillierte MOT-Einblicke",
    tierStdScore: "Worthify Buy Score (0–100)",
    tierStdStrengths: "Fahrzeugstärken & -schwächen",
    topRiskLabel: "Höchstes Risiko",
    totalMilesLabel: "Gesamtkilometer",
    totalRangeLabel: "Gesamtreichweite",
    trustAisAgreed: "KIs sind sich einig",
    trustDaysAgo: "vor {n} Tag",
    trustGdpr: "GDPR-konform",
    trustHoursAgo: "vor {n} Std.",
    trustHowItWorks: "So funktioniert's",
    trustIconAi: "KI-gestützte Risikobewertung, der Sie vertrauen können",
    trustIconData: "Vertrauenswürdige Daten aus offiziellen UK-Quellen",
    trustIconExplain: "Einfache Erklärungen für jeden",
    trustIconOne: "Ein Bericht. Alles, was Sie brauchen.",
    trustIconUk: "Entwickelt für UK-Käufer und UK-Fahrzeuge",
    trustInstant: "Sofortiger Zugriff",
    trustJustNow: "gerade eben",
    trustMinutesAgo: "vor {n} Min.",
    trustSecure: "Stripe-gesichert",
    trustVerifiedBy: "Verifiziert von",
    typeLabel: "Typ",
    tyreBrakeModalTitle: "Reifen- & Bremsenverschleiß",
    tyresLabel: "Reifen",
    ulezChargesTitle: "Tägliche Gebühr in UK-Zonen",
    ulezCompliantShort: "Konform",
    ulezCompliantTitle: "ULEZ-konform",
    ulezModalTitle: "ULEZ / Clean Air",
    ulezNonCompliantShort: "Gebührenpflichtig",
    ulezNonCompliantTitle: "Nicht ULEZ-konform",
    ulezStatusLabel: "ULEZ-Status",
    ulezUnknownNote: "DVLA hat die Euro-Emissionsklasse für dieses Kennzeichen nicht zurückgegeben. Ältere Diesel können nachgerüstet werden, und Wunschkennzeichen können ein neueres Euro-6-Fahrzeug verbergen — verifizieren Sie dies mit dem offiziellen TfL-Checker unten.",
    ulezUnknownTitle: "ULEZ-Status nicht bestätigt",
    ulezVerifyOnTfl: "Auf TfL verifizieren — offizieller Checker",
    ulezVerifyShort: "Auf TfL verifizieren",
    unknownCause: "schwerwiegender Ausfall",
    unlockItemAccident: "Unfallhistorie-Check",
    unlockItemAnomalies: "Anomalie- & Diagnosewarnungen",
    unlockItemCo2: "CO₂-Emissionen & Öko-Score",
    unlockItemCrashTest: "Crashtest & Sicherheitsbewertung",
    unlockItemDepreciation: "Wertverfall-Prognose",
    unlockItemEngineAnalysis: "Motoranalyse",
    unlockItemEngineExpert: "Motor-Experten-Urteil",
    unlockItemFailedMots: "Aufschlüsselung nicht bestandener MOTs",
    unlockItemFinance: "Offene Finanzierung-Check",
    unlockItemImport: "Import- & Exporthistorie",
    unlockItemInsurance: "Versicherungsgruppe",
    unlockItemMotHistory: "Detaillierte MOT-Historie & Mängel",
    unlockItemNegotiation: "Verhandlungsargumente (mit £-Zielen)",
    unlockItemOwners: "Vorbesitzer & V5C-Historie",
    unlockItemPdf: "Herunterladbarer PDF-Bericht",
    unlockItemPlatformExpert: "Platform Expert-Bewertung",
    unlockItemPriceCheck: "Betrugserkennung & Überhöhte Preise",
    unlockItemRecurring: "Erkennung wiederkehrender Probleme",
    unlockItemRiskExpert: "Risk Expert-Bewertung",
    unlockItemRunningCosts: "5-Jahres-Betriebskostenprognose",
    unlockItemScore: "Worthify Score mit vollständiger Aufschlüsselung",
    unlockItemSimilarSold: "Ähnliche verkaufte Fahrzeuge",
    unlockItemSimpleExplanation: "Kauf/Vermeidungs-Zusammenfassung in klarer Sprache",
    unlockItemTaxMot: "Live DVLA-Steuer- & MOT-Status",
    unlockItemTheft: "Diebstahl- & Fahndungsprüfung",
    unlockItemTopRisk: "Hauptrisiko-Zusammenfassung",
    unlockItemTyresBrakes: "Reifen- & Bremsenverschleiß-Analyse",
    unlockItemUlez: "ULEZ & CAZ Tagesgebühren-Bewertung",
    unlockItemVin: "VIN ↔ DVLA Kreuzprüfung (Klon-Erkennung)",
    unlockItemWriteOff: "Totalschaden- & Versicherungsprüfung",
    unlockMoreDataCopy: "Einmalige £4,99-Zahlung schaltet Motor, Verhandlung, Anomalien, Besitzer, Unfall, Finanzierung, ULEZ, Betriebskosten, Wertverlust und 6 weitere Prüfungen + vollständiges PDF frei.",
    unlockMoreDataLabel: "Mehr Daten freischalten",
    unlockMoreDataTitle: "15 Premium-Analysen freischalten",
    useThisToNegotiate: "Nutzen Sie dies zum Verhandeln",
    v5cIssuedLabel: "Letzter V5C",
    valueIn3Label: "Wert in 3 J.",
    valueIn5Label: "Wert in 5 J.",
    vehicleCo2Label: "CO₂-Emissionen",
    vehicleColourLabel: "Farbe",
    vehicleEngineLabel: "Motor",
    vehicleEuroLabel: "Euro-Klasse",
    vehicleFuelLabel: "Kraftstoff",
    vehicleInformationTitle: "Fahrzeuginformationen",
    vehicleMakeLabel: "Marke",
    vehicleMarkedForExportLabel: "Für Export markiert",
    vehicleMileageLabel: "Kilometerstand",
    vehicleModelLabel: "Modell",
    vehicleRegDateLabel: "Erstzulassung",
    vehicleSpecsTitle: "Technische Daten",
    vehicleTypeApprovalLabel: "Typgenehmigung",
    vehicleUlezLabel: "ULEZ",
    vehicleV5CLabel: "Letzter V5C",
    vehicleYearLabel: "Baujahr",
    verdictMainMedium: "VORSICHT",
    verdictOverpricedSub: "Der Preis von {subj} liegt bei {pct}% des Marktwerts von {median} – deutlich über dem fairen Preis.",
    verdictOverpricedTitle: "Überteuert gegenüber Markt",
    verdictPrefixHigh: "Besser",
    verdictPrefixLow: "Scheint ein",
    verdictPrefixMedium: "Fortfahren mit",
    verdictScamSub: "Der Preis von {subj} liegt bei nur {pct}% des Marktwerts von {median} – typisches Betrugsprofil.",
    verdictScamTitle: "Betrugspreis erkannt",
    verdictShortAvoid: "VERMEIDEN",
    verdictShortBeCautious: "VORSICHT WALTEN LASSEN",
    verdictShortGoodDeal: "GUTES ANGEBOT",
    verdictSuspiciousSub: "Der Preis von {subj} liegt bei nur {pct}% des Marktwerts von {median} – verdächtig niedrig.",
    verdictSuspiciousTitle: "Verdächtig niedriger Preis",
    verifiedBy3Experts: "Von 3 unabhängigen Experten geprüft",
    viewAnomalies: "Anomalien anzeigen",
    viewEngine: "Motor anzeigen",
    viewFailedTests: "Durchgefallene Tests anzeigen",
    viewHistory: "Verlauf anzeigen",
    viewIssues: "Probleme anzeigen",
    viewNegotiation: "Verhandeln",
    vinInvalidChars: "VIN darf nur Buchstaben und Zahlen enthalten",
    vinInvalidLength: "VIN muss genau 17 Zeichen lang sein",
    vinOptionalHint: "Optional · 17 Zeichen · verbessert Genauigkeit",
    vinUndecodableNote: "Ihre VIN wurde erfasst, konnte jedoch nicht von der öffentlichen US-Datenbank entschlüsselt werden. Viele reine UK-Modelle sind dort nicht gelistet – dies ist kein Warnsignal an sich.",
    vinVerifiedBadge: "VIN verifiziert",
    vinVerifiedCopy: "VIN des Verkäufers stimmt mit DVLA-Marke und -Jahr überein. Kein Klonsignal erkannt.",
    wearBothCopy: "MOT-Historie zeigt wiederholte Reifen- UND Bremsmängel. Budget £600+ für Austausch in den ersten 6 Monaten einplanen.",
    wearBrakeCopy: "MOT-Historie zeigt Bremsverschleiß. Budget £200-400 für Beläge/Scheiben-Austausch einplanen.",
    wearTyreCopy: "MOT-Historie zeigt Reifenverschleiß. Budget £300-500 für einen Satz von 4 Reifen einplanen.",
    wearWarningTitle: "Budget für Austausch einplanen",
    whatThisMeans: "Was das bedeutet",
    whatYouGetHeadline: "15 Premium-Analysen + vollständige PDF",
    whatYouGetKicker: "Premium-Freischaltung — £4.99",
    whatYouGetTitle: "Was Sie erhalten",
    whyRiskTitle: "Warum ist das ein Risiko?",
    whyThisScore: "Warum diese Bewertung?",
    worthifyExpertName: "Worthify Expert",
    worthifyExpertRole: "Fahrzeughistorie-Spezialist · 3-AI-Konsens",
    worthifyScoreLabel: "Worthify Score",
    writeOffCatA: "Nur Verschrottung",
    writeOffCatB: "Teileentsorgung",
    writeOffCatN: "Nicht strukturell",
    writeOffCatS: "Strukturschaden",
    writeOffCategoriesTitle: "Kategorie-Prüfung",
    writeOffClean: "Keine Totalschadensakte",
    writeOffFlagged: "Überprüfung erforderlich",
    writeOffModalTitle: "Totalschaden-Prüfung",
    writeOffScope: "Cat S · Cat N · Cat A · Cat B",
    yearLabel: "Jahr",
    yearPlural: "Jahre",
    yearSingular: "Jahr",
    yearlyBreakdownTitle: "Jährliche Aufschlüsselung",
    yearsLabel: "Jahre",
    yourLeverageTitle: "Ihr Verhandlungsspielraum",

    riskLevel_HIGH: "HOCH",
    riskLevel_MEDIUM: "MITTEL",
    riskLevel_LOW: "NIEDRIG",
    errorInvalidPlateChars: "In UK-Kennzeichen sind nur Buchstaben und Zahlen erlaubt.",
    legalEnNotice: "Dieses Rechtsdokument ist auf Englisch verfasst. Der Worthify-Dienst wird aus dem Vereinigten Königreich betrieben und unterliegt britischem Recht. Bei Fragen wenden Sie sich bitte an support@worthify.co.uk.",
    ninaButtonLabel: "Nina fragen — Powered by Pine",
    ninaHeaderTitle: "Nina — Ihr Auto-Kauf Co-Pilot",
    poweredByPine: "Powered by Pine",
    ninaGreeting: "Hallo! Ich habe Ihren Fahrzeugbericht für {reg} gelesen. Möchten Sie wissen, ob sich dieses Auto lohnt? Fragen Sie mich.",
    ninaInputPlaceholder: "Fragen Sie Nina alles…",
    ninaCallPitch: "Soll ich den Verkäufer anrufen und den Preis verhandeln?",
    ninaCallSellerCta: "Verkäufer anrufen — £2.99",
    ninaCalling: "Nina ruft den Verkäufer an…",
    ninaCallDone: "Anruf abgeschlossen",
    ninaCallMockSummary: "Verkäufer würde £5.700 erwägen (von £6.000). Er bittet um Rückruf heute Abend.",

    // ── Premium: echte Registerdaten (Vehicle Data Global) ──
    gvdSourceNote: "Live-Daten aus dem DVLA-Register",
    accidentSourceNote: "Live-Daten aus MIAFTR + DVLA-Fahrzeughistorie",
    miaftrSourceNote: "Live-Daten aus MIAFTR (Versicherungs-Totalschaden-Register)",
    financeSourceNote: "Live-Daten aus dem HPI / Experian Finanzregister",
    ownersKeeperLabel: "Halter",
    ownersSinceLabel: "seit",
    registryChecksTitle: "DVLA-Registerprüfungen",
    importedFlagLabel: "Importiert",
    importOutsideEuLabel: "Import von außerhalb der EU",
    importExportedLabel: "Exportiert",
    importScrappedLabel: "Verschrottet",
    ukSuppliedLabel: "In UK ausgeliefert",
    flaggedLabel: "Markiert",
    notFlaggedLabel: "Kein Eintrag",
    liveValuationTitle: "Live-Marktbewertung",
    valDealerForecourt: "Händlerpreis",
    valPrivateClean: "Privatverkauf (Top-Zustand)",
    valPartExchange: "Inzahlungnahme",
    valAuction: "Auktion",
    valMileageNote: "Bewertet bei {miles} Meilen · Live-Branchendaten",
    tyreFitmentTitle: "Werksbereifung",
    tyreFrontLabel: "Vorne",
    tyreRearLabel: "Hinten",
    priceEvalLabel: "Preisbewertung",
    mileageTileLabel: "Kilometerstand",
    dvlaSubtitle: "Führerschein- und Fahrzeugagentur",
    dvsaSubtitle: "Fahrer- und Fahrzeugstandardagentur",
    dvsaOfficialData: "Offizielle MOT-Daten",
    poweredBy: "Powered by",
    gvdSubtitle: "Partner für Nutzfahrzeugdaten",
    hpiSubtitle: "Mehr Daten als ein Standard-HPI-Check",
    errorInvalidRegistration: "Dieses Kennzeichen scheint nicht zu stimmen — bitte prüfen Sie es und versuchen Sie es erneut.",

};
